import { apiService } from "../../services/apiService";
import { apiServiceConstants } from "../../constants";
import { utilService } from "../../services/utilService";
import { doctorsListService } from "../../components/Shared/DoctorList/doctor-list-service";
import {
  FileShareFullListInterface,
  FileShareFullListModel,
  FileShareFullListResult,
} from "../FileShare/components/SelectUserComponent/SelectUserComponent.model";

const getSpecialityList = async (params: any) => {
  const respApiResult = await apiService
    .apiCall(
      `user/specialities-by-roles/?reg_code=${utilService.getNetwork()}&search_name=${""}&list=false&types=&page=${
        params.pageNo
      }`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const usersListResp = res as FileShareFullListModel;
      var resultData: any;
      const result: any = {
        isSuccess: true,
        status: usersListResp.status,
        message: usersListResp.message,
        result: usersListResp.result,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const getSpecialityUsersList = async (params: any, selectedSortId: any) => {
  const respApiResult = await apiService
    .apiCall(
      `user/global-user-search-list/?reg_code=${utilService.getNetwork()}&speciality=true&speciality_ids=${selectedSortId}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const usersListResp = res as FileShareFullListModel;
      var resultData: any;
      if (usersListResp.result) {
        resultData = mapFileShareFullListResult(usersListResp.result);
      }
      const result: FileShareFullListInterface = {
        isSuccess: true,
        status: usersListResp.status,
        message: usersListResp.message,
        result: resultData,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const getIndivualSpecialityList = async (
  params: any,
  selectedSortId: number
) => {
  const respApiResult = await apiService
    .apiCall(
      `user/global-user-search-list/?reg_code=${utilService.getNetwork()}&search_name=${
        params.search_name
      }&page=1&speciality=true&speciality_ids=${selectedSortId}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const usersListResp = res as FileShareFullListModel;
      var resultData: any;
      //   if (usersListResp.result) {
      //     resultData = mapFileShareFullListResult(usersListResp.result);
      //   }
      const result: any = {
        isSuccess: true,
        status: usersListResp.status,
        message: usersListResp.message,
        result: usersListResp.result,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const mapFileShareFullListResult = (
  payload: Array<FileShareFullListResult>
) => {
  let resultListArray = payload.map((object: FileShareFullListResult) => {
    return {
      count: object.count,
      next: object.next,
      previous: object.previous,
      data: doctorsListService.setDoctorListModel(object.data),
    };
  });
  return resultListArray;
};

const handleErrorResponse = () => {};

export const globalSpecialityService = {
  handleErrorResponse,
  getSpecialityList,
  getSpecialityUsersList,
  getIndivualSpecialityList,
};
